export default __webpack_public_path__ + "static/media/harvest-project-id.28b3bcd2.png";